import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const LeaderOfTheNation = () => {
  const navigate = useNavigate();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  return (
    <section className="main-section leader mt-5">
      <div className="container">
        <h3 className="main-section__title">{dictionary.leader}</h3>
        <div className="leader-conatiner">
          <div className="row">
            <div className="col-lg-9">
              <div className="leader-box">
                <div className="leader__img">
                  <img loading="lazy" src="img/leader.png" alt="" />
                </div>
                <div
                  className="leader-content"
                  aria-label="plate"
                >
                  <a
                    href="/president/biography"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('president/biography');
                    }}
                  >
                    <div className="leader-content__title">
                      <span>
                        {dictionary.president_text_1}
                        {' '}
                        {dictionary.president_text_2}
                      </span>
                      <span>{dictionary.emomali_rakhmon}</span>
                    </div>
                    <div className="leader-content__subtitle">
                      <span>{dictionary.biography}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="leader-link">
                <div className="leader-link__item">
                  <a
                    href="/president/power"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president/power');
                    }}
                  >
                    {dictionary.power}
                  </a>
                </div>
                <div className="leader-link__item">
                  <a
                    href="/president/symbols"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president/symbols');
                    }}
                  >
                    {dictionary.presidents_symbols}
                  </a>
                </div>
                <div className="leader-link__item">
                  <a
                    href="/president/books"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president/books');
                    }}
                  >
                    {dictionary.books}
                  </a>
                </div>
                <div className="leader-link__item">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president/articles');
                    }}
                    href="/president/articles"
                  >
                    {dictionary.articles}
                  </a>
                </div>
                <div className="leader-link__item">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president/films');
                    }}
                    href="/president/films"
                  >
                    {dictionary.films}
                  </a>
                </div>
                <div className="leader-link__item">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president/awards');
                    }}
                    href="/president/awards"
                  >
                    {dictionary.awards}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeaderOfTheNation;
